import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-3 row justify-content-center" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  style: {"height":"400px","width":"100%"},
  class: "position-relative"
}

import Api from '@/services/api';
    import { TravelCompany } from '@/services/types';
    import { ElForm, ElMessage, ElRow, FormInstance, FormRules, ElCol, ElInputNumber, ElInput, ElDivider, ElFormItem } from 'element-plus';
    import { reactive, ref } from 'vue';
    import { useRouter } from 'vue-router';
    import "leaflet/dist/leaflet.css";
    import { LMap, LTileLayer, LMarker, LTooltip} from "@vue-leaflet/vue-leaflet"
    import { LeafletMouseEvent } from 'leaflet'
    import { toFormData } from '@/utilities/helpers';
    import { useStore } from 'vuex';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CreateCompany',
  setup(__props) {

    const router = useRouter()
    const saving = ref<boolean>(false)
    const locating = ref<boolean>(false)
    const formRef = ref<FormInstance>()
    const image = ref<File | null>(null)
    const store = useStore()

    const company = reactive<TravelCompany>({
        description: '',
        image: null,
        name: '',
        area: { lat: 18.34, long: 34.18, name: '' },
        phone: null,
        password: null
    })

    const rules = ref<FormRules<TravelCompany>>({
        name: [{required: true, message: 'Preencha este campo'}],
        description: [{required: true, message: 'Preencha este campo'}],
        "area.name": [{required: true, message: 'Preencha este campo'}],
    })

    const changeFile = ({target: {files}}: any) => {
        console.log(files)
        if (files[0]) {
            image.value = files[0]
            company.image = URL.createObjectURL(files[0])
        }
    }
    
    const onMapClick = (mouseEvent: LeafletMouseEvent) => {
        const { lat, lng } = mouseEvent.latlng
        if (company.area) {
            company.area.lat = lat
            company.area.long = lng
        } else {
            company.area = {
                name: '',
                lat,
                long: lng
            }
        }
        console.log(company.area);
    }

    const locate = async () => {
        locating.value = true

        if (!navigator.geolocation) {
            alert("Geolocalização não é suportada pelo seu navegador.")
            locating.value = false
            return
        }

        navigator.geolocation.getCurrentPosition((position) => {
            if (company.area) {
                company.area.lat = position.coords.latitude
                company.area.long = position.coords.longitude
            }
            locating.value = false
        }, (err) => {
            console.log(err)
            alert("Ocorreu um erro ao tentar localizar")
            locating.value = false
        })
    }

    const submit = async (formEl: FormInstance | undefined) => {
        if (!formEl) { return }
        if (!company.area?.lat || !company.area.long) {
            ElMessage.error({message: 'Por favor selecione o local no mapa'})
            return null
        }
        await formEl.validate(async (valid) => {
            if (valid) {
                saving.value = true
                const formData = toFormData(company)
                if (image.value) {
                    formData.append("image", image.value)
                }

                const res = await Api.post('/admin/travel-companies', company, formData)
                if (res.status >= 200) {
                    store.commit('setOpenModal', -1)
                    router.push('/companies/' + res.data.company.id)
                } else {
                    console.log(res)
                    ElMessage.error({message: 'Ocorreu um erro ' + res.data.message})
                }
                saving.value = false
            }
        })
    }

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    company
      ? (_openBlock(), _createBlock(_unref(ElForm), {
          key: 0,
          disabled: saving.value,
          model: company,
          "label-position": "top",
          rules: rules.value,
          ref_key: "formRef",
          ref: formRef
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(ElFormItem), {
              label: "Nome da transportadora",
              prop: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElInput), {
                  name: "name",
                  modelValue: company.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((company.name) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(ElFormItem), {
              label: "Logotipo da empresa",
              prop: "image"
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  style: {"max-height":"250px","max-width":"100%"},
                  src: (company.image as string)
                }, null, 8, _hoisted_2),
                _createElementVNode("input", {
                  type: "file",
                  name: "image",
                  onChange: changeFile
                }, null, 32)
              ]),
              _: 1
            }),
            _createVNode(_unref(ElFormItem), {
              label: "Descricao da empres",
              prop: "description"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElInput), {
                  type: "textarea",
                  name: "description",
                  modelValue: company.description,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((company.description) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (company.area)
              ? (_openBlock(), _createBlock(_unref(ElFormItem), {
                  key: 0,
                  label: "Local",
                  prop: "area.name"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ElInput), {
                      name: "area",
                      modelValue: company.area.name,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((company.area.name) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_button, {
                plain: "",
                class: "position-absolute end-0",
                style: {"z-index":"1024"},
                loading: locating.value || saving.value,
                size: "large",
                type: "success",
                onClick: _withModifiers(locate, ["prevent"])
              }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode(" Localizar-me ", -1)
                ]))]),
                _: 1
              }, 8, ["loading"]),
              (company.area)
                ? (_openBlock(), _createBlock(_unref(LMap), {
                    key: 0,
                    onContextmenu: onMapClick,
                    ref: "map",
                    zoom: 16,
                    center: [company.area.lat, company.area.long]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(LTileLayer), {
                        url: "http://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}&s=Ga",
                        "layer-type": "base",
                        name: "OpenStreetMap"
                      }),
                      (company.area)
                        ? (_openBlock(), _createBlock(_unref(LMarker), {
                            key: 0,
                            "lat-lng": [company.area.lat, company.area.long]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(LTooltip), null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(company.name), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["lat-lng"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["center"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["disabled", "model", "rules"]))
      : _createCommentVNode("", true),
    _createVNode(_unref(ElRow), {
      justify: "space-between",
      class: "py-4"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(ElCol), { class: "col-auto" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (submit(formRef.value))),
              plain: "",
              loading: saving.value
            }, {
              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                _createTextVNode(" Salvar ", -1)
              ]))]),
              _: 1
            }, 8, ["loading"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})